import { Button } from "@blueprintjs/core";

import OutlookIcon from "@/../../hypetrain/static/img/outlook-icon.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { useAuth } from "@/components/lib/auth";
import { buildOutlookAuthorizeUrl } from "@/components/pieces/outlook-login/outlookConfig";

export const OUTLOOK_REQUIRED_SCOPES = ["Calendars.Read", "User.Read"];

export function GrantOutlookCalendarAccess() {
  const { currentWorkspace } = useAuth();
  function handleAuthorize() {
    const authorizeUrl = buildOutlookAuthorizeUrl(currentWorkspace.urlSlug);
    window.location.replace(authorizeUrl);
  }

  return (
    <Button
      icon={<EmbedSvg width={18} height={18} src={OutlookIcon} />}
      text="Connect Calendar"
      large={true}
      onClick={handleAuthorize}
      fill={true}
      style={{ marginTop: "10px" }}
    />
  );
}
